import { DatePicker, Input, InputNumber, message, Select, Switch } from 'antd';
import { postSpuUpdate } from '@/api';
import { FormModal, UploadImage } from '@/components';
import { ergodicObj, toDateTime } from '@/utils/utils';
import { st_banner } from '@/utils/statetype';
import React, { useEffect, useState } from 'react';

const { positionObj, typeObj } = st_banner;
function BannderEdit({ visible, data, onChange }) {

  const handleSubmit = async params => {
    console.log("params:", params)
    if (!params) return onChange();
    const { isRecommend, describe } = params;

    data.id && await postSpuUpdate({
      body: {
        ids: [data.id],
        ...params,
        isRecommend: isRecommend ? 1 : 0,
        info: JSON.stringify({ describe }),
        describe: undefined
      },
    })
    message.success('操作成功');
    onChange(true);
  };

  const formData = [
    data?.id && {
      name: 'id',
      label: '编号',
      rules: [{ required: false, message: '请输入编号' }],
      render: <InputNumber disabled placeholder="请输入编号" />,
    },
    {
      name: 'name',
      label: '商品名称',
      rules: [{ required: true, message: '请输入商品名称' }],
      render: <Input placeholder="请输入商品名称" />,
    },
    {
      name: 'describe',
      label: '商品详情',
      rules: [{ required: true, message: '请输入商品详情' }],
      render: <Input.TextArea placeholder="请输入商品详情" />,
    },
    {
      name: 'thumb',
      label: '封面图',
      rules: [{ required: true, message: '请选择封面图' }],
      render: <UploadImage model="single" callBackString />,
    },
    {
      name: 'bannerImage',
      label: '兑换商品轮播图',
      rules: [{ required: true, message: '请选择兑换商品轮播图' }],
      render: <UploadImage callBackString />,
    },
    {
      name: 'image',
      label: '详情图',
      rules: [{ required: true, message: '请选择详情图' }],
      render: <UploadImage callBackString />,
    },
    {
      name: 'credNote',
      label: '鉴定证书',
      rules: [{ required: true, message: '请选择鉴定证书' }],
      render: <UploadImage callBackString />,
    },
    {
      name: 'isRecommend',
      label: '是否推荐',
      rules: [{ required: false, message: '请输入是否推荐' }],
      render: <Switch
        defaultChecked={data?.isRecommend === 1}
        checkedChildren='启用'
        unCheckedChildren='隐藏'
      />,
    },
  ];

  return (
    <FormModal
      title="商品"
      visible={visible}
      formData={formData}
      initialValues={data}
      onChange={handleSubmit}
    />
  );
}

export default BannderEdit;
